export const getCodenameBySlug = (slug: string) => slug.replace(/-/g, '_')
